import {useEffect} from "react";
import echarts from "echarts/lib/echarts";
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/markPoint'

function useEcharts(ref, config) {
    let chartInst = null;

    function render() {
        const renderedInst = echarts.getInstanceByDom(ref.current);
        if (renderedInst) {
            chartInst = renderedInst;
        } else {
            chartInst = echarts.init(ref.current);
        }
        chartInst.setOption(config);
    }

    useEffect(() => {
        render();
    }, [config]);

    useEffect(() => () => {
        chartInst && chartInst.dispose();
    }, [chartInst]); 
}

export default useEcharts;